import React, {useEffect, useRef, useState} from "react";
import {Button, Col, Modal, Row, Space, Typography, Watermark} from "antd";
import ReactToPrint from "react-to-print";
import {gioiTinhOptions} from "assets/constants/select-catagory-options";
import dayjs from "dayjs";
import {payService} from "api";
import {columns, getTodayString} from "./ModalPrint.config";
import {useAppSelector} from "redux/hooks";
import moment from "moment";
import "./ModalPrint.scss";
import {
  convertCurrencyToWords,
  convertIosDateToString,
  formatToCurrencyTypeFloor,
  formatToCurrencyTypeNoFloor,
  convertDateStringToDateTimezone_7,
  convertDateStringToDateTimezone_7Dayjs,
  formatDateToString,
} from "helper/common";
import {HeaderPage, HeaderPrintForm} from "components/common";
import {FORMAT_TIME} from "types/enums";
import BoxBHYT from "./BoxBHYT/BoxBHYT";
import Notification from "../../../../../components/common/notification/notification";
const {Text} = Typography;

const ModalPrint = props => {
  const {isShowModal, handleOk, handleCancel, coPhuThu} = props;
  const printRef = useRef<any>();
  const [thongTinIn, setThongTinIn] = useState<any>(null);
  const [data, setData] = useState([]);
  const [tempDatatable, settempDatatable] = useState([]);
  const [tongTien, setTongTien] = useState(0);
  const [allGiaTien, setAllGiaTien] = useState<any>();
  const idLanKham = useAppSelector(state => state.reduxCommon.id);
  const idBh = useAppSelector(state => state.common.idReceiptPrint);
  const [tenThuNgan, setTenThuNgan] = useState<any>();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  useEffect(() => {
    getData();
  }, [isShowModal, idLanKham]);
  const handelOnExport = async () => {
    const dataexcel = {
      idPhieuKham: thongTinIn?.idPhieuKham,
      coPhuThu: coPhuThu,
    };
    try {
      const response = await payService.getExportBangKe(dataexcel).then(res => {
        // console.log("res export", res);
        var link = document.createElement("a");
        const url = window.URL.createObjectURL(res.data);
        link.href = url;
        link.download = `Báo cáo bảng kê nội trú.xlsx`;
        link.click();
        Notification("success", "Đã xuất file báo cáo");
      });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi xuất file báo cáo");
    }
  };
  const tinhTongDonGiaBenhVien = data => {
    let donGiaBaoHiem = 0;
    let donGiaBenhVien = 0;
    let thanhTien = 0;
    let thanhTienBaoHiem = 0;
    let quyBHYT = 0;
    let nguoiBenhCungChiTra = 0;
    let nguoiBenhTuTra = 0;
    let khac = 0;

    data.forEach(item => {
      if (item.children && item.children.length > 0) {
        item.children.forEach(childItem => {
          donGiaBaoHiem += childItem.donGiaBaoHiem || 0;
          donGiaBenhVien += childItem.donGiaBenhVien || 0;
          thanhTien += childItem.thanhTien || 0;
          thanhTienBaoHiem += childItem.thanhTienBaoHiem || 0;
          quyBHYT += childItem.quyBHYT || 0;
          nguoiBenhCungChiTra += childItem.nguoiBenhCungChiTra || 0;
          nguoiBenhTuTra += childItem.nguoiBenhTuTra || 0;
          khac += childItem.khac || 0;
        });
      }
    });

    const tongObject = {
      key: "tongCong",
      noiDung: "Cộng",
      // donViTinh: 0,
      // soLuong: 0,
      // donGiaBaoHiem,
      // donGiaBenhVien,
      thanhTien,
      thanhTienBaoHiem,
      quyBHYT,
      nguoiBenhCungChiTra,
      nguoiBenhTuTra,
      khac,
    };

    setTongTien(tongObject?.thanhTien);
    setAllGiaTien(tongObject);
    return tongObject;
  };

  // Gọi hàm và hiển thị kết quả

  const getData = async () => {
    try {
      let response = await payService
        .getDataBangKe(idLanKham, coPhuThu)
        .then(res => {
          // console.log("data in thu bang ke", res);
          const newData = res.data.dataTable.noiDungs;
          const dataTable = newData.map(item => {
            return {
              key: item.tenNoiDung,
              noiDung: item.tenNoiDung,
              nguoiBenhTuTra: item.nguoiBenhTuTra,
              quyBHYT: item.quyBHYT,
              thanhTien: item.thanhTien,
              thanhTienBaoHiem: item.thanhTienBaoHiem,
              nguoiBenhCungChiTra: item.nguoiBenhCungChiTra,

              children: item.noiDung.map((e, idx) => {
                return {
                  ...e,
                  key: `${e.noiDung}${idx}${
                    Math.random() * (9999999 - 1 + 1) + 1
                  }`,
                };
              }),
            };
          });

          settempDatatable(dataTable);
          tinhTongDonGiaBenhVien(dataTable);

          setThongTinIn(res.data);
          setData(dataTable.filter(e => e.children.length > 0));
        });
    } catch (err) {
      setData([]);
    }
  };

  const expandAllRows = () => {
    const keys = [];
    const expandKeys = data => {
      data.forEach(item => {
        keys.push(item.key);
        if (item.children) {
          expandKeys(item.children);
        }
      });
    };
    expandKeys(data);
    setExpandedRowKeys(keys);
  };

  useEffect(() => {
    expandAllRows();
  }, [isShowModal, idLanKham, data]);

  const onPrint = async () => {
    window.print();
  };

  const capitalizeFirstLetter = str => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const renderTime = (time, utc) => {
    // Lấy thông tin giờ, phút và ngày

    const inputTime = new Date(time);
    const hours = utc ? inputTime.getUTCHours() : inputTime.getHours();
    const minutes = utc ? inputTime.getUTCMinutes() : inputTime.getMinutes();

    const style = {width: "13px"};
    return (
      <Space direction="horizontal" style={{width: "100%"}}>
        <div>
          <Space direction="horizontal">
            <Row style={style} justify={"center"}>
              <Text>{time && !isNaN(hours) ? hours : ""}</Text>
            </Row>
            <Row justify={"center"}>
              <Text>giờ</Text>
            </Row>
          </Space>
        </div>
        <div>
          <Space direction="horizontal">
            <Row style={style} justify={"center"}>
              <Text>
                {time && !isNaN(minutes)
                  ? minutes < 10
                    ? "0" + minutes
                    : minutes
                  : ""}
              </Text>
            </Row>
            <Row justify={"center"}>
              <Text>phút,</Text>
            </Row>
          </Space>
        </div>
        <div>
          <Space direction="horizontal">
            <Row justify={"center"}>
              <Text>ngày</Text>
            </Row>
            <Row justify={"center"}>
              <Text>
                {time && !utc ? moment(time).format(FORMAT_TIME.dayFull) : ""}
              </Text>
              <Text>
                {time && utc
                  ? moment.utc(time).format(FORMAT_TIME.dayFull)
                  : ""}
              </Text>
            </Row>
          </Space>
        </div>
      </Space>
    );
  };

  return (
    <Modal
      centered
      open={isShowModal}
      onCancel={handleCancel}
      closable={false}
      footer={null}
      width={1000}
      className="modal-custom-print-HDT"
    >
      <div className="print-thanh-toan-bang-ke">
        <div>
          <div
            ref={printRef}
            style={{paddingRight: "10px", width: "210mm", margin: "auto"}}
          >
            <Row justify={"space-between"}>
              <Col span={17}>
                <Space direction="vertical" size={60}>
                  <Row>
                    <Row justify={"start"}>
                      <Typography.Text strong>BỘ Y TẾ</Typography.Text>
                    </Row>
                    <Row justify={"start"}>
                      <Typography.Text strong>
                        BỆNH VIỆN CHUYÊN KHOA MẮT ALINA
                      </Typography.Text>
                    </Row>
                    <Row justify={"start"}>
                      <Typography.Text strong>
                        Khoa: Khoa mắt tổng hợp
                      </Typography.Text>
                    </Row>
                    <Row justify={"start"}>
                      <Typography.Text strong>Mã khoa: K30</Typography.Text>
                    </Row>
                  </Row>
                </Space>
              </Col>
              <Col span={7}>
                <Space direction="vertical" size={60}>
                  <Row>
                    <Row justify={"start"}>
                      <Typography.Text strong>Mẫu số: 01/KBCB</Typography.Text>
                    </Row>
                    <Row justify={"start"}>
                      <Typography.Text strong>
                        Mã số người bệnh: {thongTinIn?.maBenhNhan}
                      </Typography.Text>
                    </Row>
                    <Row justify={"start"}>
                      <Typography.Text strong>
                        Số khám bệnh: {thongTinIn?.soKhamBenh}
                      </Typography.Text>
                    </Row>
                  </Row>
                </Space>
              </Col>
            </Row>
            {/* <HeaderPrintForm /> */}
            <Row>
              <Row justify={"center"}>
                <Col span={2}></Col>
                <Col span={20} style={{textAlign: "center"}}>
                  <Typography.Title
                    style={{
                      fontWeight: "700",
                      fontSize: "20px",
                      margin: 0,
                    }}
                  >
                    BẢNG KÊ CHI PHÍ ĐIỀU TRỊ NỘI TRÚ
                  </Typography.Title>
                </Col>
                <Col span={2}>
                  <Typography.Text style={{display: "flex"}}>
                    <label
                      className="custom-checkbox-header"
                      style={{width: "20px", height: "20px"}}
                    >
                      <input checked value={3} type="checkbox" />
                      <span></span>
                    </label>
                  </Typography.Text>
                </Col>
              </Row>
              <Row>
                <Row>
                  <Typography.Text strong>I. Phần hành chính:</Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col span={9}>
                    <Typography.Text>
                      (1) Họ tên người bệnh: {thongTinIn?.hoTen?.toUpperCase()}
                    </Typography.Text>
                  </Col>
                  <Col span={7}>
                    <Typography.Text style={{display: "flex"}}>
                      Ngày,tháng,năm sinh:{" "}
                      {thongTinIn?.ngaySinh
                        ? convertDateStringToDateTimezone_7(
                            thongTinIn?.ngaySinh
                          ).format(FORMAT_TIME.dayFull)
                        : ""}
                    </Typography.Text>
                  </Col>
                  <Col span={5}>
                    <Typography.Text style={{display: "flex"}}>
                      Giới tính:{" "}
                      {
                        gioiTinhOptions.find(
                          it => it.value === thongTinIn?.gioiTinh
                        )?.label
                      }
                    </Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={17}>
                    <Typography.Text>
                      (2) Địa chỉ hiện tại: &nbsp;
                      <Typography.Text>
                        {thongTinIn?.diaChiTongHop}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col span={6}>
                    <Typography.Text>
                      (3) Mã khu vực (K1/K2/K3): &nbsp;
                      <Typography.Text>{thongTinIn?.maKhuVuc}</Typography.Text>
                    </Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <Row>
                      (4) Mã thẻ BHYT: &nbsp;
                      <BoxBHYT code={thongTinIn?.maTheBhyt ?? ""} />
                    </Row>
                  </Col>
                  <Col span={5}>
                    <Typography.Text>
                      Giá trị từ: &nbsp;
                      <Typography.Text>
                        {convertIosDateToString(thongTinIn?.ngayBHYTBatDau)}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col span={6}>
                    <Typography.Text>
                      Đến: &nbsp;
                      <Typography.Text>
                        {convertIosDateToString(thongTinIn?.ngayBHYTKetThuc)}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={17}>
                    <Typography.Text>
                      (5) Nơi ĐK KCB ban đầu: &nbsp;
                      <Typography.Text>{thongTinIn?.noiDkkcbd}</Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col span={6}>
                    <Typography.Text>
                      (6) Mã: &nbsp;
                      <Typography.Text>
                        {thongTinIn?.maNoiDkkcbbd}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={5}>
                    <Text>(7) Đến khám:</Text>
                  </Col>
                  <Col flex={"auto"}>
                    {renderTime(thongTinIn?.ngayDieuTri, false)}
                  </Col>
                </Row>
                <Row>
                  <Col span={5}>
                    <Text>(8) Điều trị ngoại trú/nội trú từ:</Text>
                  </Col>
                  <Col flex={"auto"}>
                    {renderTime(thongTinIn?.ngayDieuTri, false)}
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <Row>
                      <Col span={10}>
                        <Text>(9) Kết thúc khám/điều trị:</Text>
                      </Col>
                      <Col flex={"auto"}>
                        {renderTime(thongTinIn?.ngayKetThucKham, false)}
                      </Col>
                    </Row>
                  </Col>
                  <Col span={5}>
                    <Typography.Text>
                      Tổng số ngày điều trị: &nbsp;
                      <Typography.Text>
                        {isNaN(
                          new Date(thongTinIn?.ngayKetThucKham).getUTCDay() -
                            new Date(thongTinIn?.ngayDieuTri).getUTCDay()
                        )
                          ? ""
                          : thongTinIn?.ngayKetThucKham &&
                            thongTinIn?.ngayDieuTri &&
                            new Date(thongTinIn?.ngayKetThucKham).getUTCDay() -
                              new Date(thongTinIn?.ngayDieuTri).getUTCDay() +
                              1}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col span={6}>
                    <Typography.Text>
                      (10) Tình trạng ra viện: &nbsp;
                      <Typography.Text>
                        {thongTinIn?.tinhTrangRaVien}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={3}>
                    <Typography.Text style={{display: "flex"}}>
                      (11) Cấp cứu: &nbsp;
                      <label className="custom-checkbox">
                        <input
                          checked={thongTinIn?.capCuu ? true : false}
                          type="checkbox"
                        />
                        <span></span>
                      </label>
                    </Typography.Text>
                  </Col>
                  <Col span={4}>
                    <Typography.Text style={{display: "flex"}}>
                      (12) Đúng tuyến: &nbsp;
                      <label className="custom-checkbox">
                        <input
                          checked={thongTinIn?.dungTuyen ? true : false}
                          type="checkbox"
                        />
                        <span></span>
                      </label>
                    </Typography.Text>
                  </Col>
                  <Col span={5}>
                    <Typography.Text>
                      Nơi chuyển từ: &nbsp;
                      <Typography.Text>
                        {thongTinIn?.noiChuyenDenTu}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col span={5}>
                    <Typography.Text>
                      Nơi chuyển đi: &nbsp;
                      <Typography.Text>
                        {thongTinIn?.noiChuyenDiTu}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col span={4}>
                    <Typography.Text style={{display: "flex"}}>
                      (13) Thông tuyến: &nbsp;
                      <label className="custom-checkbox">
                        <input
                          checked={thongTinIn?.thongTuyen ? true : false}
                          type="checkbox"
                        />
                        <span></span>
                      </label>
                    </Typography.Text>
                  </Col>
                  <Col span={3}>
                    <Typography.Text style={{display: "flex"}}>
                      (14) Trái tuyến:
                      <label className="custom-checkbox">
                        <input
                          checked={thongTinIn?.traiTuyen ? true : false}
                          type="checkbox"
                        />
                        <span></span>
                      </label>
                    </Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={17}>
                    <Typography.Text>
                      (15) Chẩn đoán xác định: &nbsp;
                      <Typography.Text>
                        {thongTinIn?.chanDoanXacDinh}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col span={6}>
                    <Typography.Text style={{display: "flex"}}>
                      (16) Mã bệnh: &nbsp;
                      <label className="custom-checkbox-text">
                        <span> {thongTinIn?.maBenh}</span>
                      </label>
                    </Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Typography.Text>
                    (17) Bệnh kèm theo: &nbsp;
                    <Typography.Text>{thongTinIn?.benhKemTheo}</Typography.Text>
                  </Typography.Text>
                </Row>
                <Row>
                  <Typography.Text style={{display: "flex"}}>
                    (18) Mã bệnh kèm theo: &nbsp;
                    <label
                      className="custom-checkbox-text"
                      style={{width: "120px"}}
                    >
                      <span> {thongTinIn?.maBenhKemTheo}</span>
                    </label>
                  </Typography.Text>
                </Row>
                <Row>
                  <Col span={12}>
                    <Typography.Text>
                      (19) Thời điểm đủ 5 năm liên tục từ ngày: &nbsp;
                      <Typography.Text>
                        {convertDateStringToDateTimezone_7Dayjs(
                          thongTinIn?.lienTuc5NamTuNgay,
                          FORMAT_TIME.dayFull
                        )}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col span={12}>
                    <Typography.Text>
                      Miễn cùng chi trả trong năm từ ngày: &nbsp;
                      <Typography.Text>
                        {convertDateStringToDateTimezone_7Dayjs(
                          thongTinIn?.mienChiTraTrongNamTuNgay,
                          FORMAT_TIME.dayFull
                        )}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                </Row>
              </Row>
              <Row>
                <Row>
                  <Typography.Text strong>
                    II. Phần chi phí khám bệnh, chữa bệnh
                    <Typography.Text
                      style={{fontStyle: "italic", fontWeight: "400"}}
                    >
                      (Mỗi mã thẻ BHYT thống kê chi phí khám bệnh phát sinh
                      tương ứng theo mã thẻ đó).
                    </Typography.Text>
                  </Typography.Text>
                </Row>
                <Row>
                  <Col span={10}>
                    <Row>
                      Mã thẻ BHYT: &nbsp;
                      <BoxBHYT code={thongTinIn?.maTheBhyt ?? ""} />
                    </Row>
                  </Col>
                  <Col span={4}>
                    <Typography.Text>
                      Giá trị từ: &nbsp;
                      <Typography.Text>
                        {convertIosDateToString(thongTinIn?.ngayBHYTBatDau)}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col span={4}>
                    <Typography.Text>
                      Đến: &nbsp;
                      <Typography.Text>
                        {convertIosDateToString(thongTinIn?.ngayBHYTKetThuc)}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col span={6}>
                    <Typography.Text style={{display: "flex"}}>
                      Mức hưởng: &nbsp;
                      <label
                        className="custom-checkbox-text"
                        style={{width: "70px"}}
                      >
                        <span> {thongTinIn?.mucHuongBHYT}</span>
                      </label>
                    </Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Typography.Text>
                    (Chi phí KBCB tính từ ngày{" "}
                    {thongTinIn?.ngayDenKham &&
                      moment(thongTinIn?.ngayDenKham).format(
                        FORMAT_TIME.dayFull
                      )}{" "}
                    đến ngày{" "}
                    {thongTinIn?.ngayKetThucKham &&
                      moment(thongTinIn?.ngayKetThucKham).format(
                        FORMAT_TIME.dayFull
                      )}
                    )
                  </Typography.Text>
                </Row>
              </Row>
              <Row>
                <table className="table-custom-bang-ke">
                  <thead>
                    <tr></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        rowSpan={2}
                        className="table-content"
                        style={{
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        Nội dung
                      </td>
                      <td
                        className="table-remain-content"
                        style={{fontWeight: "bold"}}
                        rowSpan={2}
                      >
                        Đơn vị tính
                      </td>
                      <td
                        className="table-remain-content"
                        style={{fontWeight: "bold"}}
                        rowSpan={2}
                      >
                        Số lượng
                      </td>
                      <td className="table-remain-content" rowSpan={2}>
                        <div style={{fontWeight: "bold"}}>Đơn giá BV</div>
                        <div style={{fontStyle: "italic"}}>(đồng)</div>
                      </td>
                      <td className="table-remain-content" rowSpan={2}>
                        <div style={{fontWeight: "bold"}}>Đơn giá BH</div>
                        <div style={{fontStyle: "italic"}}>(đồng)</div>
                      </td>
                      <td className="table-remain-content" rowSpan={2}>
                        <div style={{fontWeight: "bold"}}>
                          Tỷ lệ thanh toán theo dịch vụ
                        </div>
                        <div style={{fontStyle: "italic"}}>(%)</div>
                      </td>
                      <td className="table-remain-content" rowSpan={2}>
                        <div style={{fontWeight: "bold"}}>Thành tiền BV</div>
                        <div style={{fontStyle: "italic"}}>(đồng)</div>
                      </td>
                      <td className="table-remain-content" rowSpan={2}>
                        <div style={{fontWeight: "bold"}}>
                          Tỷ lệ thanh toán BHYT
                        </div>
                        <div style={{fontStyle: "italic"}}>(%)</div>
                      </td>
                      <td className="table-remain-content" rowSpan={2}>
                        <div style={{fontWeight: "bold"}}>Thành tiền BH</div>
                        <div style={{fontStyle: "italic"}}>(đồng)</div>
                      </td>
                      <td className="table-remain-content" colSpan={4}>
                        <span style={{fontWeight: "bold"}}>
                          Nguồn thanh toán
                        </span>

                        <span>(đồng)</span>
                      </td>
                    </tr>
                    <tr>
                      <td
                        className="table-remain-content"
                        style={{fontWeight: "bold"}}
                      >
                        Quỹ BHYT
                      </td>
                      <td
                        className="table-remain-content"
                        style={{fontWeight: "bold"}}
                      >
                        Người bệnh cùng chi trả
                      </td>
                      <td
                        className="table-remain-content"
                        style={{fontWeight: "bold"}}
                      >
                        Khác
                      </td>
                      <td
                        className="table-remain-content"
                        style={{fontWeight: "bold"}}
                      >
                        Người bệnh tự trả
                      </td>
                    </tr>
                    <tr>
                      <td
                        className="table-content"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        (1)
                      </td>
                      <td className="table-remain-content">(2)</td>
                      <td className="table-remain-content">(3)</td>
                      <td className="table-remain-content">(4)</td>
                      <td className="table-remain-content">(5)</td>
                      <td className="table-remain-content">(6)</td>
                      <td className="table-remain-content">(7)</td>
                      <td className="table-remain-content">(8)</td>
                      <td className="table-remain-content">(9)</td>
                      <td className="table-remain-content">(10)</td>
                      <td className="table-remain-content">(11)</td>
                      <td className="table-remain-content">(12)</td>
                      <td className="table-remain-content">(13)</td>
                    </tr>

                    {/* Check xem có nagyf giường hay không? */}
                    {tempDatatable?.[1]?.children?.length > 0 && (
                      <tr>
                        <td className="table-td-title" colSpan={6}>
                          {tempDatatable?.[0]?.key}
                        </td>

                        {/* <tr></tr> */}
                        <td className="table-td-title2">
                          {formatToCurrencyTypeNoFloor(
                            tempDatatable?.[0]?.thanhTien
                          )}
                        </td>
                        <td> </td>
                        <td className="table-td-title2">
                          {formatToCurrencyTypeNoFloor(
                            tempDatatable?.[0]?.thanhTienBaoHiem
                          )}
                        </td>
                        <td className="table-td-title2">
                          {formatToCurrencyTypeNoFloor(
                            tempDatatable?.[0]?.quyBHYT
                          )}
                        </td>
                        <td className="table-td-title2">
                          {formatToCurrencyTypeNoFloor(
                            tempDatatable?.[0]?.nguoiBenhCungChiTra
                          )}
                        </td>
                        <td></td>
                        <td className="table-td-title2">
                          {formatToCurrencyTypeNoFloor(
                            tempDatatable?.[0]?.nguoiBenhTuTra
                          )}
                        </td>
                      </tr>
                    )}
                    {/* Map theo dịch vụ bố */}
                    {data?.map((item, index) => {
                      return (
                        <>
                          <tr>
                            <td className="table-td-title" colSpan={6}>
                              {item.key}
                            </td>

                            {/* <tr></tr> */}
                            <td className="table-td-title2">
                              {formatToCurrencyTypeNoFloor(item.thanhTien)}
                            </td>
                            <td> </td>
                            <td className="table-td-title2">
                              {formatToCurrencyTypeNoFloor(
                                item.thanhTienBaoHiem
                              )}
                            </td>
                            <td className="table-td-title2">
                              {formatToCurrencyTypeNoFloor(item.quyBHYT)}
                            </td>
                            <td className="table-td-title2">
                              {formatToCurrencyTypeNoFloor(
                                item.nguoiBenhCungChiTra
                              )}
                            </td>
                            <td></td>
                            <td className="table-td-title2">
                              {formatToCurrencyTypeNoFloor(item.nguoiBenhTuTra)}
                            </td>
                          </tr>
                          {/* Map dịch vụ con trong dịch vụ bố */}
                          {item.children.map(child => {
                            return (
                              <tr>
                                <td className="table-content">
                                  {child.noiDung}
                                </td>
                                <td>{child.donViTinh}</td>
                                <td className="table-remain-content">
                                  {child.soLuong}
                                </td>
                                <td className="table-content-right">
                                  {formatToCurrencyTypeNoFloor(
                                    child.donGiaBenhVien
                                  )}
                                </td>
                                <td className="table-content-right">
                                  {formatToCurrencyTypeNoFloor(
                                    child.donGiaBaoHiem
                                  )}
                                </td>
                                <td className="table-content-center">
                                  {child.tyLeThanhToanDichVu}
                                </td>
                                <td className="table-content-right">
                                  {formatToCurrencyTypeNoFloor(child.thanhTien)}
                                </td>
                                <td className="table-content-center">
                                  {formatToCurrencyTypeNoFloor(
                                    child?.tyLeThanhToanBHYT
                                  )}
                                </td>
                                <td className="table-content-right">
                                  {formatToCurrencyTypeNoFloor(
                                    child?.thanhTienBaoHiem
                                  )}
                                </td>
                                <td className="table-content-right">
                                  {formatToCurrencyTypeNoFloor(child.quyBHYT)}
                                </td>
                                <td className="table-content-right">
                                  {formatToCurrencyTypeNoFloor(
                                    child.nguoiBenhCungChiTra
                                  )}
                                </td>
                                <td className="table-content-right">
                                  {formatToCurrencyTypeNoFloor(child.khac)}
                                </td>
                                <td className="table-content-right">
                                  {formatToCurrencyTypeNoFloor(
                                    child.nguoiBenhTuTra
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      );
                    })}

                    <tr>
                      <td colSpan={6} className="table-td-title">
                        Cộng:
                      </td>
                      <td className="table-td-title">
                        {formatToCurrencyTypeFloor(allGiaTien?.thanhTien)}
                      </td>
                      <td className="table-td-title">
                        {/* {formatToCurrencyTypeNoFloor(allGiaTien?.thanhTien)} */}
                      </td>
                      <td className="table-td-title">
                        {formatToCurrencyTypeFloor(
                          allGiaTien?.thanhTienBaoHiem
                        )}
                      </td>
                      <td className="table-td-title">
                        {formatToCurrencyTypeFloor(allGiaTien?.quyBHYT)}
                      </td>
                      <td className="table-td-title">
                        {formatToCurrencyTypeFloor(
                          allGiaTien?.nguoiBenhCungChiTra
                        )}
                      </td>
                      <td className="table-td-title">
                        {/* {formatToCurrencyTypeNoFloor(allGiaTien?.thanhTien)} */}
                      </td>{" "}
                      <td className="table-td-title">
                        {formatToCurrencyTypeFloor(allGiaTien?.nguoiBenhTuTra)}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr></tr>
                  </tfoot>
                </table>
              </Row>
              <Row>
                <Space>
                  <Text>
                    Tổng chi phí lần khám bệnh/cả đợt điều trị{" "}
                    <Typography.Text italic>
                      (làm tròn đến đợn vị đồng)
                    </Typography.Text>{" "}
                    :{" "}
                    <Typography.Text strong>
                      {tongTien
                        ? formatToCurrencyTypeFloor(tongTien) + " đồng"
                        : ""}
                    </Typography.Text>
                  </Text>
                  <Typography.Text strong>
                    {formatToCurrencyTypeFloor(thongTinIn?.tongThanhToan)}
                  </Typography.Text>
                </Space>
              </Row>
              <Row>
                <Text italic>
                  (Viết bằng chữ:{" "}
                  <Text strong>
                    {capitalizeFirstLetter(
                      convertCurrencyToWords(Math.round(tongTien) ?? "")
                    )}
                  </Text>
                </Text>
                )
              </Row>
              <Row>
                <Text>Trong đó, số tiền do:</Text>
              </Row>
              <Row style={{paddingLeft: "20px"}} justify={"start"}>
                <Col span={7}>
                  <Text> - Quỹ BHYT thanh toán :</Text>
                </Col>
                <Col flex={"auto"}>
                  <Typography.Text strong italic>
                    {capitalizeFirstLetter(
                      convertCurrencyToWords(
                        Math.round(allGiaTien?.quyBHYT) ?? ""
                      )
                    )}
                  </Typography.Text>
                </Col>
              </Row>
              <Row style={{paddingLeft: "20px"}}>
                <Col span={7}>
                  <Text> - Người bệnh trả, trong đó :</Text>
                </Col>
                <Col flex={"auto"}>
                  <Typography.Text strong italic>
                    {capitalizeFirstLetter(
                      convertCurrencyToWords(
                        Math.round(
                          allGiaTien?.nguoiBenhCungChiTra +
                            allGiaTien?.nguoiBenhTuTra
                        )
                      ) ?? ""
                    )}
                  </Typography.Text>
                </Col>
              </Row>
              <Row style={{paddingLeft: "40px"}}>
                <Col span={6}>
                  <Text> + Cùng trả trong phạm vi BHYT :</Text>
                </Col>
                <Col flex={"auto"}>
                  <Typography.Text strong italic style={{paddingLeft: "17px"}}>
                    {capitalizeFirstLetter(
                      convertCurrencyToWords(
                        Math.round(allGiaTien?.nguoiBenhCungChiTra) ?? ""
                      )
                    )}
                  </Typography.Text>
                </Col>
              </Row>
              <Row style={{paddingLeft: "40px"}}>
                <Col span={6}>
                  <Text> + Các khoản phải trả khác :</Text>
                </Col>
                <Col flex={"auto"}>
                  <Typography.Text strong italic style={{paddingLeft: "17px"}}>
                    {capitalizeFirstLetter(
                      convertCurrencyToWords(
                        Math.round(allGiaTien?.nguoiBenhTuTra) ?? ""
                      )
                    )}
                  </Typography.Text>
                </Col>
              </Row>
              <Row style={{paddingLeft: "20px"}}>
                <Space>
                  <Text> - Nguồn khác :</Text>
                  <Typography.Text strong>
                    {capitalizeFirstLetter(
                      thongTinIn?.nguonKhac ? thongTinIn?.nguonKhac : "không"
                    )}
                  </Typography.Text>
                </Space>
              </Row>
              <Row>
                <Row justify={"end"}>
                  <Typography.Text
                    className="date-sign"
                    italic
                    style={{marginRight: "35px"}}
                  >
                    {thongTinIn?.ngayKetThucKham
                      ? dayjs(thongTinIn?.ngayKetThucKham).format(
                          `Ngày DD [tháng] MM [năm] YYYY`
                        )
                      : dayjs().format(`Ngày DD [tháng] MM [năm] YYYY`)}
                    {/* {thongTinIn?.ngayKetThucKham ? getTodayString()} */}
                  </Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>
                          NGƯỜI LẬP BẢNG KÊ
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text italic>
                          (Ký và ghi rõ họ tên)
                        </Typography.Text>
                      </Row>
                    </Row>
                  </Col>
                  <Col>
                    <Space direction="vertical" size={60}>
                      <Row>
                        <Row justify={"center"}>
                          <Typography.Text strong>
                            KẾ TOÁN VIỆN PHÍ
                          </Typography.Text>
                        </Row>
                        <Row justify={"center"}>
                          <Typography.Text italic>
                            (Ký và ghi rõ họ tên)
                          </Typography.Text>
                        </Row>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>
                          {/* {thongTinIn?.tenThuNgan
                            ? thongTinIn?.tenThuNgan
                            : localStorage.getItem("fullName")} */}
                        </Typography.Text>
                      </Row>
                    </Space>
                  </Col>
                </Row>
                <Row></Row>
              </Row>
              <Row style={{marginTop: "10px"}}>
                <Row justify={"end"}>
                  <Typography.Text
                    className="date-sign"
                    italic
                    style={{marginRight: "35px"}}
                  >
                    Ngày....tháng....năm....
                  </Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Row>
                      <Col style={{paddingLeft: "15px"}}>
                        <Row justify={"center"}>
                          <Typography.Text strong>
                            XÁC NHẬN CỦA NGƯỜI BỆNH
                          </Typography.Text>
                        </Row>
                        <Row justify={"center"}>
                          <Typography.Text italic>
                            (Ký và ghi rõ họ tên)
                          </Typography.Text>
                        </Row>
                        <Row justify={"center"}>
                          <Typography.Text strong italic>
                            (Tôi đã nhận......phim......Xquang/CT/MRI)
                          </Typography.Text>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Space direction="vertical" size={60}>
                      <Row>
                        <Row justify={"center"}>
                          <Typography.Text strong>
                            GIÁM ĐỊNH BHYT
                          </Typography.Text>
                        </Row>
                        <Row justify={"center"}>
                          <Typography.Text italic>
                            (Ký và ghi rõ họ tên)
                          </Typography.Text>
                        </Row>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>
                          {thongTinIn?.tenGiamDinhBHYT}
                        </Typography.Text>
                      </Row>
                    </Space>
                  </Col>
                </Row>
                <Row></Row>
              </Row>
            </Row>
          </div>
        </div>
        <Row justify={"end"} style={{padding: "12px", gap: "4px"}}>
          <Space direction="horizontal">
            <Button type="primary" onClick={handelOnExport}>
              Xuất excel
            </Button>
            <Button danger type="primary" onClick={handleCancel}>
              HỦY
            </Button>
            <ReactToPrint
              trigger={() => {
                return (
                  <Button type="primary" onClick={onPrint}>
                    IN
                  </Button>
                );
              }}
              content={() => printRef.current}
              onAfterPrint={handleCancel}
              // onBeforeGetContent={()}
              bodyClass="print-thanh-toan-bang-ke"
              pageStyle={"padding:20px 0"}
            />
          </Space>
        </Row>
      </div>
    </Modal>
  );
};

export default ModalPrint;
